import { RightOutlined } from '@ant-design/icons';
import { FlexRow } from '@framework/ui';
import { Card, Flex, Typography } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
const { Text, Title } = Typography;

const StyledLinkedSubmissionCard = styled(Card)`
  border: 2px solid ${({ theme }) => theme.colorPrimary};
  background-color: ${({ theme }) => theme.colorBgContainer};
  &.dark {
    background-color: ${({ theme }) => theme.colorPrimary};
  }
  .ant-card-body {
    padding: 16px;
    /* padding-right: 24px; */
  }
`;
const LinkedSubmissionTitleText = styled(Text)`
  &&& {
    font-size: 22px;
    line-height: 28px;
    font-weight: 600;
    .dark & {
      color: ${({ theme }) => theme.colorBgContainer};
    }
  }
`;
const LinkedSubmissionSummaryText = styled(Text)`
  &&& {
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    .dark & {
      color: ${({ theme }) => theme.colorBgContainer};
    }
  }
`;
const LinkedSubmissionArrowWrapper = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colorPrimaryBorder};
  color: ${({ theme }) => theme.colorBgContainer};
  .dark & {
    background-color: ${({ theme }) => theme.colorBgContainer};
    color: ${({ theme }) => theme.colorPrimaryBorder};
  }
`;

export interface LinkedSubmissionCardProps {
  summary?: string;
  title?: string;
  linkedSubmissionId?: string;
  action?: React.ReactNode;
  /** versione con fondo scuro */
  dark?: boolean;
}

/**
 * Card per la visualizzazione del link di una richiesta collegata
 */
export function LinkedSubmissionCard(props: LinkedSubmissionCardProps) {
  const { summary, title, action, dark, linkedSubmissionId } = props;

  // const { data: linkedSubmission } = useGetFrontRichiesteId(
  //   linkedSubmissionId ?? '',
  // );

  return (
    <StyledLinkedSubmissionCard className={clx({ dark })}>
      <FlexRow
        gutter={12}
        left={
          <LinkedSubmissionArrowWrapper>
            <RightOutlined aria-hidden />
          </LinkedSubmissionArrowWrapper>
        }
        right={action ?? undefined}
      >
        <Flex vertical>
          {summary && (
            <LinkedSubmissionSummaryText>{summary}</LinkedSubmissionSummaryText>
          )}
          <LinkedSubmissionTitleText>{title}</LinkedSubmissionTitleText>
        </Flex>
      </FlexRow>
    </StyledLinkedSubmissionCard>
  );
}
